import { lazy, Suspense, useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const Home = lazy(() => import("./pages/Home"));
const Contact = lazy(() => import("./pages/Contact"));
const About = lazy(() => import("./pages/About"));
const Courses = lazy(() => import("./pages/Courses"));
const DetailPage = lazy(() => import("./pages/Courses/detailPage"));
const AuthPage = lazy(() => import("./pages/User"));
const DashboardPage = lazy(() => import("./pages/Dashboard/dashboard"));
const DashboardIndex = lazy(() => import("./pages/Dashboard/index"));
const ProfilePage = lazy(() => import("./pages/Profile"));
const UsersPage = lazy(() => import("./pages/Dashboard/UsersPage"));
const CoursePage = lazy(() => import("./pages/Dashboard/CoursePage"));
const ModulePage = lazy(() => import("./pages/Dashboard/ModulesPage"));
const ReviewsPage = lazy(() => import("./pages/Dashboard/ReviewsPage"));
const AddVideoPage = lazy(() => import("./pages/Dashboard/AddVideoPage"));
const StudentDetail = lazy(() => import("./pages/StudentDetail"));
const CartPage = lazy(() => import("./pages/Courses/cartPage"));
const CheckoutPage = lazy(() => import("./pages/Courses/paymentModel"));
const PlayVideoPage = lazy(() => import("./pages/Courses/courseVideoPlayer"));
const WatchHistoryPage = lazy(
  () => import("./pages/Dashboard/WatchHistoryPage"),
);
const CourseFlow = lazy(() => import("./pages/Courses/courseFlowPage"));
const WelcomePageNew = lazy(() => import("./pages/WelcomePage"));
const VideoPage = lazy(() => import("./pages/Video"));
const ForgotPassword = lazy(() => import("./pages/User/forgotPassword"));
const ResetPassword = lazy(() => import("./pages/User/resetPassword"));
const CertificatePage = lazy(() => import("./pages/Courses/certificatePage"));
const EnrollInline = lazy(() => import("./pages/Courses/enrollFreePage"));
const AdminProtectedRoute = lazy(
  () => import("./components/Routes/adminProtectRoute"),
);

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App" style={{ width: "100%" }}>
      <ToastContainer position="top-right" autoClose={3000} />
      <HelmetProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Suspense
            fallback={
              <div
                style={{
                  minHeight: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "18px",
                }}
              >
                Loading...
              </div>
            }
          >
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
              <Route path="/courses" element={<Courses />} />
              <Route
                path="/courses/:title"
                element={<DetailPage />}
              />
              <Route path="/:title" element={<DetailPage />} />
              <Route
                path="/courses/detailPage/:title/cart"
                element={<CartPage />}
              />
              <Route path="/user" element={<AuthPage />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/studentDetails" element={<StudentDetail />} />
              <Route path="/payment" element={<CheckoutPage />} />
              <Route path="/ThankyouPage" element={<CourseFlow />} />
              <Route path="/courseVideoPlayer" element={<PlayVideoPage />} />
              <Route path="/welcome" element={<WelcomePageNew />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route
                path="/reset-password/:token"
                element={<ResetPassword />}
              />
              <Route path="/video" element={<VideoPage />} />
              <Route path="/certificatePage" element={<CertificatePage />} />
              <Route path="/enroll" element={<EnrollInline />} />
              <Route element={<AdminProtectedRoute />}>
                <Route path="/dashboard" element={<DashboardIndex />}>
                  <Route index element={<DashboardPage />} />
                  <Route path="users" element={<UsersPage />} />
                  <Route path="course" element={<CoursePage />} />
                  <Route path="modules" element={<ModulePage />} />
                  <Route path="reviews" element={<ReviewsPage />} />
                  <Route path="addvideo" element={<AddVideoPage />} />
                  <Route path="studentHistory" element={<WatchHistoryPage />} />
                </Route>
              </Route>
            </Routes>
          </Suspense>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
